import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import DaumPostcode from 'react-daum-postcode';

import { useropen } from '../../redux/userInfo';
import consts from '../../libs/consts';

import { open, close, loadingflas } from '../../redux/popupSlice';

import { Link, useNavigate } from 'react-router-dom';
import { addHyphenToPhoneNumber, getBase64, patternPwCker, regEmail, getMemberinfo, getBase64toDataUrl } from "../../utils/utils";

import Input from '../../component/Input';
import Button from '../../component/Button';
import Radios from '../../component/Radios';

import * as APIS from "../../utils/service";

export default function Storetype1Write({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const selectFile = useRef(null);
    const selectFile2 = useRef(null);
    const { configdata } = useSelector(s => s.configReducer);
    const [memberinfos, setmemberinfos] = useState(''); 

    let leavelists = configdata?.consts?.leaveOptionConsts;
    let leavechData = [];
    leavelists?.map((x, i) => {
        leavechData.push({
            // names: x?.title,
            comments: x?.desc,
            values: x?.idx,
        });
    });
    //console.log(leavechData);
    const [leaveOptionlist, setleaveOptionlist] = useState(leavechData);   
    const [errmsg, seterrmsg] = useState(['', '', '', '', '', '']);   
    const [submitflag, setsubmitflag] = useState(false);   


    const [title, settitle] = useState(''); //상호명
    const [ceo, setceo] = useState(''); //대표자명 
    const [business_number, setbusiness_number] = useState(''); //사업자번호
    const [permit_number, setpermit_number] = useState(''); //허가(등록)번호
    const [detail_addr, setdetail_addr] = useState(''); //상세주소
    const [popstatus, setpopstatus] = useState(false);   
    const [isOpenPost, setIsOpenPost] = useState(false);
    const [files, setfiles] = useState([{}, {}]);   
    const [addrDatas, setaddrDatas] = useState({});   
    const [leave_option, setleave_option] = useState(1);   
    const [modifyfiles1, setmodifyfiles1] = useState({});   
    const [modifyfiles2, setmodifyfiles2] = useState({});   
    const [company_phone, setcompany_phone] = useState('');   
    
    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
    useEffect(() => {
        const { compony } = memberinfos;
        if(compony?.status*1 === 99){
            settitle(compony?.title);
            setceo(compony?.ceo);
            setbusiness_number(compony?.business_number);
            setpermit_number(compony?.permit_number);
            setaddrDatas({
                addr: compony?.addr,
                sido: compony?.sido,
                sigungu: compony?.sigungu
            });
            setdetail_addr(compony?.detail_addr);
            setcompany_phone(compony?.company_phone);

            let file = consts.s3url+"/"+compony?.business_path;
            getBase64toDataUrl(file, function(myBase64) {
                setmodifyfiles1({
                    base64: myBase64,
                    ext: compony?.business_path.split('.')[1]
                });
                
            });

            file = consts.s3url+"/"+compony?.compony_path;
            getBase64toDataUrl(file, function(myBase64) {
                setmodifyfiles2({
                    base64: myBase64,
                    ext: compony?.compony_path.split('.')[1]
                });
            });            
            
        }
    }, [memberinfos]);
    useEffect(() => {
        console.log(modifyfiles1, modifyfiles2);
        if(modifyfiles1 && modifyfiles1){
            setfiles([modifyfiles1, modifyfiles2]);
        }
    }, [modifyfiles1, modifyfiles2]);

    useEffect(() => {
        console.log(files);
    }, [files]);

    useEffect(() => {
        seterrmsg(errmsg?.map(( xe, ie ) => ''));
        setsubmitflag(false);
        //console.log(files);
        if(
            title !== '' &&
            ceo !== '' &&
            business_number !== '' &&
            permit_number !== '' &&
            detail_addr !== '' &&
            addrDatas?.addr &&
            files[0]?.base64 && files[1]?.base64
        ){
            setsubmitflag(true);
        }
        //console.log(addrDatas?.addr);

    }, [title, ceo, business_number, permit_number, detail_addr, addrDatas, files]);

    const onCompletePost = (data) => {
        let fullAddr = data.address;
        let extraAddr = '';

        //console.log('data', data);
        
        //let jibunAddress = jibunAddress;

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddr += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddr += extraAddr !== '' ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddr += extraAddr !== '' ? ` (${extraAddr})` : '';
        }
        console.log(data);

        setaddrDatas({
            addr: data.address,
            sido: data?.sido,
            sigungu: data?.sigungu || data?.sido
        });
        
        setIsOpenPost(false);
    };
    const postBoxStyle = {
        display: 'block',
        position: 'relative',
        width: '100%',
        border: '1px solid #000',
        marginTop: 5,
        textAlign: 'right'
    };
    const postCodeStyle = {
        width: '100%',
        borderTop: '1px solid #000',
    };

    const registerCompanySubmit = () => {

        dispatch(loadingflas({ loading: true }));
        //navigate('/Storeselctor');

        let sender = {
            title: title,
            ceo: ceo,
            business_number: business_number,
            permit_number: permit_number,
            sido: addrDatas?.sido,
            sigungu: addrDatas?.sigungu,
            addr: addrDatas?.addr,
            detail_addr: detail_addr,
            leave_option: leave_option,
            company_phone: company_phone,
            share_option: 1,
            business_path: {
                base: files[0]?.base64,
                ext: files[0]?.ext
            },
            compony_path: {
                base: files[1]?.base64,
                ext: files[1]?.ext
            },
        }


        console.log(sender);
        
        APIS.postData('/v1/compony/join', sender).then(({ data }) => {
            console.log(data);
            if(data){
                //localStorage.setItem("token", data);
                setpopstatus(false);
                navigate('/StoretypeFin', {state: sender});
            }
        }).catch(({ response }) => {
            console.log(response);
            const { data } = response;
            setpopstatus(false);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });   
    }

    return(
        <>
        <Layout header={false}>
            <div className='normalformw1000 heightgap40'>
                <div className="pageinfoNumbering">
                    <b>02</b>/ 02
                </div>
            </div>
            <div className='normalform' style={{ marginTop: 20 }}>
                <div className='normalform_title'>[대표공인중개사]님 사무소를 등록해 주세요.</div>

                <div className='inputArea'>
                    <Input 
                        className={`inputs`}
                        setValue={settitle}
                        value={title}
                        name="searchvar1"
                        label={'상호'}
                        labelstyle={2}
                        error={errmsg[0]}
                        clearflag={true}
                        requireds={true}
                        customplaceholder={true}
                        customplaceholdertxt={'상호'}
                    />                    
                </div>                        
                <div className='inputArea'>
                    <Input 
                        className={`inputs`}
                        setValue={setceo}
                        value={ceo}
                        name="searchvar2"
                        label={'대표자명'}
                        labelstyle={2}
                        error={errmsg[1]}
                        clearflag={true}
                        requireds={true}
                        customplaceholder={true}
                        customplaceholdertxt={'대표자명'}
                    />                    
                </div>               
                <div className='inputArea'>
                    <Input 
                        className={`inputs`}
                        setValue={setcompany_phone}
                        value={company_phone}
                        name="searchvar3"
                        label={'대표번호'}
                        labelstyle={2}
                        error={errmsg[3]}
                        clearflag={true}
                        requireds={true}
                        customplaceholder={true}
                        customplaceholdertxt={'대표번호'}
                    />                    
                </div>    

                <div className='inputArea'>
                    <Input 
                        className={`inputs`}
                        setValue={setbusiness_number}
                        value={business_number}
                        name="searchvar3"
                        label={'사업자번호'}
                        labelstyle={2}
                        error={errmsg[2]}
                        clearflag={true}
                        requireds={true}
                        customplaceholder={true}
                        customplaceholdertxt={'사업자번호'}
                    />                    
                </div>       
                <div className='inputArea'>
                    <Input 
                        className={`inputs`}
                        setValue={setpermit_number}
                        value={permit_number}
                        name="searchvar3"
                        label={'허가(등록)번호'}
                        labelstyle={2}
                        error={errmsg[3]}
                        clearflag={true}
                        requireds={true}
                        customplaceholder={true}
                        customplaceholdertxt={'허가(등록)번호'}
                    />                    
                </div>       

                <div className='buttonWithTxt'>
                    <div>
                        <Button
                            className={'normalbutton_middle'}
                            buttonTxt={'주소찾기'}
                            onPress={() => {
                                setIsOpenPost(true);
                            }}
                        />
                    </div>
                    <div>
                        {addrDatas?.addr}
                    </div>
                </div>
                {isOpenPost  ? (
                    <div style={postBoxStyle}>
                        <button type="button" className="addrbtn exit_btn" onClick={() => setIsOpenPost(false)} style={{ padding: 10 }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.79289C5.68342 5.40237 6.31658 5.40237 6.70711 5.79289L12 11.0858L17.2929 5.79289C17.6834 5.40237 18.3166 5.40237 18.7071 5.79289C19.0976 6.18342 19.0976 6.81658 18.7071 7.20711L13.4142 12.5L18.7071 17.7929C19.0976 18.1834 19.0976 18.8166 18.7071 19.2071C18.3166 19.5976 17.6834 19.5976 17.2929 19.2071L12 13.9142L6.70711 19.2071C6.31658 19.5976 5.68342 19.5976 5.29289 19.2071C4.90237 18.8166 4.90237 18.1834 5.29289 17.7929L10.5858 12.5L5.29289 7.20711C4.90237 6.81658 4.90237 6.18342 5.29289 5.79289Z" fill="#999999"/>
                            </svg>                            
                        </button>
                        <DaumPostcode style={postCodeStyle} autoClose onComplete={onCompletePost} />
                    </div>
                ) : null}                
                <div className='inputArea'>
                    <Input 
                        className={`inputs`}
                        setValue={setdetail_addr}
                        value={detail_addr}
                        name="searchvar"
                        label={'상세주소'}
                        labelstyle={2}
                        error={errmsg[4]}
                        clearflag={true}
                        requireds={true}
                        customplaceholder={true}
                        customplaceholdertxt={'상세주소'}                        
                    />                    
                </div> 

                <input type='file' ref={selectFile} style={{ display: 'none' }} onChange={(e) => {
                    let file = e.target.files[0];
                    getBase64(file).then(result => {
                        file["base64"] = result;
                        file["ext"] = file.name.split('.')[1];
                        console.log(file, files?.map((x, i) => i === 0 ? file : x ));
                        setfiles(files?.map((x, i) => i === 0 ? file : x ));
                    })
                    .catch(err => { console.log(err); });
                }} />             
                <input type='file' ref={selectFile2} style={{ display: 'none' }} onChange={(e) => {
                    let file = e.target.files[0];
                    getBase64(file).then(result => {
                        file["base64"] = result;
                        file["ext"] = file.name.split('.')[1];
                        setfiles(files?.map((x, i) => i === 1 ? file : x ));
                    })
                    .catch(err => { console.log(err); });
                }} />                        
                <div
                    style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 20
                    }}
                >
                    <div>
                        <div className='normalform_comment' style={{ marginTop: 20 }}>중개사무소등록증<span style={{ color: 'red' }}>*</span></div>
                        {files[0]?.base64 ? 
                        <div className="write_image_list" >
                            <div style={{ backgroundImage: `url(${files[0]?.base64})`}}>
                                <button 
                                    type="button"
                                    onClick={() => {
                                        seterrmsg(errmsg?.map(( xe, ie ) => ''));
                                        setfiles(files?.map((x, i) => i === 0 ? {} : x ));
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                        <rect x="0.333984" width="16" height="16" rx="4" fill="#101010"/>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M5.5683 5.23431C5.88072 4.9219 6.38725 4.9219 6.69967 5.23431L8.53398 7.06863L10.3683 5.23431C10.6807 4.9219 11.1873 4.9219 11.4997 5.23431C11.8121 5.54673 11.8121 6.05327 11.4997 6.36569L9.66536 8.2L11.4997 10.0343C11.8121 10.3467 11.8121 10.8533 11.4997 11.1657C11.1873 11.4781 10.6807 11.4781 10.3683 11.1657L8.53398 9.33137L6.69967 11.1657C6.38725 11.4781 5.88072 11.4781 5.5683 11.1657C5.25588 10.8533 5.25588 10.3467 5.5683 10.0343L7.40261 8.2L5.5683 6.36569C5.25588 6.05327 5.25588 5.54673 5.5683 5.23431Z" fill="white"/>
                                    </svg>                
                                </button>
                            </div>
                        </div>                        
                        :
                        <div className="write_image_list">
                            <button type="button"
                            onClick={() => {
                                selectFile.current.click();
                            }}                            
                            >
                                <p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M14.1053 13C14.1053 14.1579 13.1579 15.1053 12 15.1053C10.8421 15.1053 9.89474 14.1579 9.89474 13C9.89474 11.8421 10.8421 10.8947 12 10.8947C13.1579 10.8947 14.1053 11.8421 14.1053 13ZM22 10.8947V16.1579C22 18.7632 19.8684 20.8947 17.2632 20.8947H6.73684C4.13158 20.8947 2 18.7632 2 16.1579V10.8947C2 8.36842 3.97368 6.31579 6.44737 6.15789L7.76316 4.15789C8.26316 3.42105 9.07895 3 9.94737 3H14C14.8947 3 15.6842 3.44737 16.1842 4.15789L17.5 6.15789C20.0263 6.31579 22 8.36842 22 10.8947ZM16.2105 13C16.2105 10.6842 14.3158 8.78947 12 8.78947C9.68421 8.78947 7.78947 10.6842 7.78947 13C7.78947 15.3158 9.68421 17.2105 12 17.2105C14.3158 17.2105 16.2105 15.3158 16.2105 13ZM19.3684 9.84211C19.3684 9.26316 18.8947 8.78947 18.3158 8.78947C17.7368 8.78947 17.2632 9.26316 17.2632 9.84211C17.2632 10.4211 17.7368 10.8947 18.3158 10.8947C18.8947 10.8947 19.3684 10.4211 19.3684 9.84211Z" fill="#6164A5"/>
                                </svg>             
                                </p>
                                <p>업로드</p>
                            </button>
                        </div>                           
                        }
                    </div>
                    <div>
                        <div className='normalform_comment' style={{ marginTop: 20 }}>사업자등록증<span style={{ color: 'red' }}>*</span></div>
                        {files[1]?.base64 ? 
                        <div className="write_image_list" >
                            <div style={{ backgroundImage: `url(${files[1]?.base64})`}}>
                                <button 
                                    type="button"
                                    onClick={() => {
                                        seterrmsg(errmsg?.map(( xe, ie ) => ''));
                                        setfiles(files?.map((x, i) => i === 1 ? {} : x ));
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                        <rect x="0.333984" width="16" height="16" rx="4" fill="#101010"/>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M5.5683 5.23431C5.88072 4.9219 6.38725 4.9219 6.69967 5.23431L8.53398 7.06863L10.3683 5.23431C10.6807 4.9219 11.1873 4.9219 11.4997 5.23431C11.8121 5.54673 11.8121 6.05327 11.4997 6.36569L9.66536 8.2L11.4997 10.0343C11.8121 10.3467 11.8121 10.8533 11.4997 11.1657C11.1873 11.4781 10.6807 11.4781 10.3683 11.1657L8.53398 9.33137L6.69967 11.1657C6.38725 11.4781 5.88072 11.4781 5.5683 11.1657C5.25588 10.8533 5.25588 10.3467 5.5683 10.0343L7.40261 8.2L5.5683 6.36569C5.25588 6.05327 5.25588 5.54673 5.5683 5.23431Z" fill="white"/>
                                    </svg>                
                                </button>
                            </div>
                        </div>                        
                        :                        
                        <div className="write_image_list">
                            <button type="button"
                            onClick={() => {
                                selectFile2.current.click();
                            }}                            
                            >
                                <p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M14.1053 13C14.1053 14.1579 13.1579 15.1053 12 15.1053C10.8421 15.1053 9.89474 14.1579 9.89474 13C9.89474 11.8421 10.8421 10.8947 12 10.8947C13.1579 10.8947 14.1053 11.8421 14.1053 13ZM22 10.8947V16.1579C22 18.7632 19.8684 20.8947 17.2632 20.8947H6.73684C4.13158 20.8947 2 18.7632 2 16.1579V10.8947C2 8.36842 3.97368 6.31579 6.44737 6.15789L7.76316 4.15789C8.26316 3.42105 9.07895 3 9.94737 3H14C14.8947 3 15.6842 3.44737 16.1842 4.15789L17.5 6.15789C20.0263 6.31579 22 8.36842 22 10.8947ZM16.2105 13C16.2105 10.6842 14.3158 8.78947 12 8.78947C9.68421 8.78947 7.78947 10.6842 7.78947 13C7.78947 15.3158 9.68421 17.2105 12 17.2105C14.3158 17.2105 16.2105 15.3158 16.2105 13ZM19.3684 9.84211C19.3684 9.26316 18.8947 8.78947 18.3158 8.78947C17.7368 8.78947 17.2632 9.26316 17.2632 9.84211C17.2632 10.4211 17.7368 10.8947 18.3158 10.8947C18.8947 10.8947 19.3684 10.4211 19.3684 9.84211Z" fill="#6164A5"/>
                                </svg>             
                                </p>
                                <p>업로드</p>
                            </button>
                        </div>      
                        }                  
                    </div>
                </div>
                {errmsg[5] !== '' &&
                <div>
                    <p className="input_error"><span></span>{errmsg[5]}</p>
                </div>
                }

                <div className='loginbutton' style={{ marginTop: 20 }}>
                    <Button
                        disabled={!submitflag}
                        onPress={() => {
                            //registerCompanySubmit();
                            //navigate('/Storeselctor');
                            if(submitflag === true){
                                setpopstatus(true);
                            }
                        }}
                        buttonTxt={'완료'}
                    />
                </div>     
            </div>            
        </Layout>
        {popstatus === true &&
        <div className='PopupArea'>
            <div>
                <div 
                    className='PopupAreaBG' 
                    //onClick={() => { setpopstatus(false); }}
                />
                <div
                    className='PopupAreaContents'
                >
                    <div className='radiopop1'>
                        <div>매물/고객 정보 귀속 여부 설정</div>
                        <div>
                            <p>[{title}]</p>
                            <p>소속된 직원들의 퇴사 시</p>
                            <p>매물/고객정보에 대한 귀속 여부를 설정해 주세요.</p>
                        </div>
                        
                        <div>
                            <Radios
                                style={{alignItems:"start"}}
                                linetype={'comment'}
                                values={leave_option}
                                setvalues={setleave_option}
                                namevalue={leaveOptionlist}
                                flexDirection={'column'}
                            />  
                        </div>
        

                        <div>해당 설정은 가입완료 후 사무소 설정에서 변경하실 수 있습니다.</div>
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', gap: 10 }}>
                            <Button
                                styles={{ width: 80, backgroundColor: '#666' }}
                                onPress={() => {
                                    setpopstatus(false);
                                }}
                                buttonTxt={'닫기'}
                            />
                            <Button
                                className={'normalbutton'}
                                buttonTxt={'완료'}
                                onPress={() => { 
                                    registerCompanySubmit();
                                }}
                            />
                        </div>
                                        
                    </div>
                </div>
            </div>
        </div>
        }
        </>
    )
}

